<template>
  <footer id="footer" :class="locale">
    <div class="footer-top">
      <div class="footer-inner">
        <div class="footer-fl">
          <a :href="$link('www')" class="footer-top-link">{{ $trans('首页') }}</a>
        </div>
      </div>
    </div>
    <div class="footer-wrapper">
      <div class="footer-content">
        <div class="footer-list">
          <ul v-for="(sub, index) in menus" v-bind:key="index">
            <li @click="getActiveH5(sub.name)" :class="['footer-title', { active: activeMenuName === sub.name }]">{{ sub.name }}<i></i></li>
            <div :class="['footer-box-h5', { 'footer-active-h5': activeMenuName === sub.name }]">
              <li v-for="(item, i) in sub.children" v-bind:key="i">
                <span v-if="!item.hide">
                  <a v-if="item.url" @click="sendAnalytics(item.label)" :href="item.url">{{ item.name }}</a>
                  <span v-else v-html="item.name"></span>
                </span>
              </li>
            </div>
          </ul>
          <ul class="footer-icon">
            <li class="footer-title">{{ $trans('关注我们') }}</li>
            <div>
              <li class="footer-follow-us">
                <div @click="target(item.url, item.label)" class="item-follow-us" v-for="(item, index) in followUsList" v-bind:key="index">
                  <img :src="item.img" alt="BITMAIN - Contact" class="footer-contact-ico" />
                  <div v-if="!isMobile" class="item-list" :class="item.name">
                    <img class="QR-code" :src="item.imgCode" alt="" />
                    <div class="info">
                      <p><img class="icon" :src="item.imgIcon" alt="" /> {{ item.name }}</p>
                      <p>{{ item.company }}</p>
                      <p>{{ item.url }}</p>
                    </div>
                  </div>
                </div>
                <div @click="target('','bitmainAccounts')" class="item-follow-us follow-us-more">
                  <img src="./images/more.png" alt="BITMAIN - Contact" class="footer-contact-ico more" />
                  <img src="./images/right.png" alt="BITMAIN - Contact" class="footer-contact-ico right" />
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright">
      <span>{{ $trans('© 2023 比特大陆科技控股公司') }}</span>
      <a @click="sendAnalytics('termsOfUse')" :href="$link('disclaimer')" class="footer-link footer-first-link">{{ $trans('法律声明') }}</a>
      <a @click="sendAnalytics('privacyPolicy')" :href="$link('privacy')" class="footer-link">{{ $trans('隐私政策') }}</a>
    </div>
  </footer>
</template>
<script>
import links from '../links';

import icon01 from './images/icon-twitter.png';
import icon02 from './images/icon-youtube.png';
import icon03 from './images/icon-facebook.png';
import icon04 from './images/icon-telegram.png';

const i18n = {
  zh: {},
  en: {
    首页: 'Home',
    新闻与活动: 'News & Events',
    关于我们: 'Our Company',
    联系我们: 'Contact Us',
    招贤纳士: 'Careers',
    法律声明: 'Terms of Use',
    隐私政策: 'Privacy Policy',
    关注我们: 'Follow Us',
    服务支持: 'Customer Support',
    联系销售: 'Contact Sales',
    关于比特大陆: 'About BITMAIN',
    公司信息: 'Our Company',
    博客: 'Blog',
    服务与支持: 'Support & Services',
    质保期查询: 'Warranty Check',
    产品固件: 'Firmware',
    维修平台: 'Repair',
    蚂蚁矿机: 'Product',
    热线电话: 'Hotline',
    账户管理: 'Manage Your Account',
    KYC验证: 'Submit KYC',
    优惠券:'COUPON',
    战略合作: 'Strategic Partners',
    区域销售邮箱:'Regional Sales Email',
    北美区:'NA',
    泛欧区:'EMCIS',
    泛亚区:'ASIA',
    区域销售即时通讯APP:'Regional Sales IM APP',
    '© 2023 比特大陆科技控股公司': 'Copyright © 2023 BITMAIN Technologies Holding Company. All Rights Reserved.',
  },
};

export default {
  props: {
    // 埋点方法，默认为空
    // sendAnalytics: {
    //   type: Function,
    //   default: function() {},
    // },
    env: {
      type: String,
      default: 'production',
    },
    // 当前语言，默认值为英文, 可选值为：en, zh
    locale: {
      type: String,
      default: 'en',
    },
    getRouter: {
      type: Function,
      default: () => {},
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    isMycart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: false,
      isMobile: this.mobile,
      activeMenuName: '',
      sites: {},
      menus: this.reloadMenu(),
      followUsList: [
        { 
          img: require('./images/twitter.png'), 
          imgCode: require('./images/code-twitter-bitmain.png'),
          imgIcon: icon01,
          name: 'Twitter',
          company: 'BITMAIN',
          url: 'https://twitter.com/BITMAINtech', 
          label: 'twitter' 
        },
        { 
          img: require('./images/telegram.png'), 
          imgCode: require('./images/code-telegram.png'), 
          imgIcon: icon02,
          name: 'Telegram',
          company: 'BITMAIN',
          url: 'https://t.me/bitmain',
          label: 'telegram' },
        { 
          img: require('./images/youtube.png'), 
          imgCode: require('./images/code-youtube.png'), 
          imgIcon: icon03,
          name: 'YouTube',
          company: 'BITMAIN',
          url: 'https://www.youtube.com/c/Bitmain_official',
          label: 'youtube' 
        },
        { 
          img: require('./images/facebook.png'), 
          imgCode: require('./images/code-facebook.png'), 
          imgIcon: icon04,
          name: 'Facebook',
          company: 'BITMAIN',
          url: 'https://www.facebook.com/BITMAIN',
          label: 'facebook' 
        },
      ],
    };
  },
  mounted() {
    this.isMobile = document.body.clientWidth <= 768;
  },
  watch: {
    locale() {
      this.menus = this.reloadMenu();
    },
  },
  methods: {
    sendAnalytics(name) {
      const sendEvent = this.sendEvent || window.sendEvent;
      if (sendEvent) {
        const label = i18n.en[name] || name;
        sendEvent('底部', `bitmain-footer-${label}`);
      }
    },
    $trans(key) {
      let messages = i18n[this.locale];
      return messages[key] || key;
    },
    $link(type) {
      const router = this.getRouter(type);
      if (router) {
        return router;
      }
      const language = this.locale === 'zh' ? 'zh' : 'en';
      const key = this.env === 'production' ? language : `${language}Beta`;
      return links[key][type] || '';
    },
    reloadMenu() {
      return [
        {
          name: this.$trans('关于比特大陆'),
          children: [
            { name: this.$trans('新闻与活动'), url: this.$link('news'), label: 'news' },
            { hide: this.locale === 'en' ? false :true, name: this.$trans('博客'), url: this.$link('blog'), label: 'blog' },
            { name: this.$trans('招贤纳士'), url: this.$link('job'), label: 'job' },
          ],
        },
        {
          name: this.$trans('服务支持'),
          children: [
            { name: this.$trans('热线电话') + ' +1(717)502-4531' },
            { name: this.$trans('联系销售'), url: this.$link('contactSales'), label: 'contactSales' },
            { name: 'SUPPORT.BITMAIN.COM', url: this.$link('support'), label: 'support' },
            { name: this.$trans('账户管理'), url: this.$link('sso'), label: 'sso' },
            { name: this.$trans('KYC验证'), url: this.$link('kyc'), label: 'kyc' },
            { hide: this.isMobile ? true : false, name: this.$trans('优惠券'), url: this.$link('coupon'), label: 'coupon' },
          ],
        },
        // {
        //   name: this.$trans('区域销售邮箱'),
        //   children: [
        //     { name: this.$trans('北美区') + '<br />AntminerNA@bitmain.com' },
        //     { name: this.$trans('泛欧区') + '<br />AntminerEMCIS@bitmain.com' },
        //     { name: this.$trans('泛亚区') + '<br />AntminerASIA@bitmain.com' },
        //   ],
        // },
        {
          name: this.$trans('战略合作'),
          children: [
            { name: 'ANTPOOL', url: this.$link('antpool'), label: 'antpool' },
            { name: 'BITFUFU', url: this.$link('bitfufu'), label: 'bitfufu' },
            { name: 'ANTALPHA', url: this.$link('antalpha'), label: 'antalpha' },
          ],
        },
      ];
    },
    getActiveH5(name) {
      this.activeMenuName = this.activeMenuName === name ? '' : name;
    },
    target(url, label) {
      if (url !== '') {
        window.location.href = url;
      }else{
        window.location.href = this.$link('bitAccounts')
      }
      this.sendAnalytics(label)
    },
  },
};
</script>
<style lang="less" scoped>
@maxWidth: 1380px;
footer {
  font-family: 'Arial', 'Red Hat Text', 'lucida grande', 'lucida sans unicode', lucida, helvetica, 'Hiragino Sans GB', 'Microsoft YaHei', 'WenQuanYi Micro Hei',
    sans-serif;
  width: 100%;
  background: #f2f4f6;
  a{
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  &.en {
    .wrapper {
      .footer-content {
        .footer-list {
          ul {
            li {
              &:first-child {
                //font-weight: bold;
              }

              a {
                font-weight: normal;
              }
            }
          }
        }
        .hotline {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.7);
          margin: 10px 0 0;
        }
      }
    }
  }

  .footer-top {
    width: 100%;
    border-bottom: 1px solid #e2e4e7;

    .footer-inner {
      width: 90%;
      max-width: @maxWidth;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: #000;
      line-height: 52px;

      .footer-fl {
        float: left;
      }

      .footer-fr {
        float: right;
      }
    }

    .footer-top-link {
      font-size: 16px;
      color: #000;
      line-height: 52px;
      font-weight: 500;
    }
  }

  .footer-icon {
    li {
      &.li-icons {
        margin-left: 44px;
      }
    }
    .footer-follow-us{
      position: relative;
      .item-follow-us{
        display: inline-block;
        margin-right: 10px;
        cursor: pointer;
        &:hover{
          .item-list {
            display: flex;
          }
        }
        &.follow-us-more{
          .more{
            display: inline-block;
          }
          .right{
            display: none;
          }
          &:hover{
            .more{
              display: none;
            }
            .right{
              display: inline-block;
            }
          }
        }
        img.footer-contact-ico {
          height: 20px;
          color: #969698;
          display: inline-block;
          vertical-align: middle;
          
        }
      }
      .item-list {
        position: absolute;
        left: -40px;
        top: 40px;
        display: none;
        margin-bottom: 30px;
        padding: 12px 8px;
        // border-top: 1px solid #8B8B8B;
        cursor: pointer;
        &::before{
          content: '';
          width: 8px;
          height: 8px;
          border-top: 1px solid #8B8B8B;
          border-right: 1px solid #8B8B8B;
          background: #f2f4f6;
          transform: rotate(-45deg);
          position: absolute;
          top: -5px;
          z-index: 1;
        }
        &::after{
          content: '';
          width: 270px;
          height: 1px;
          background: #8B8B8B;
          position: absolute;
          top: 0px;
          left: 0px;
        }
        &.Twitter{
          &::before{
            left: 50px;
          }
        }
        &.Telegram{
          &::before{
            left: 80px;
          }
        }
        &.YouTube{
          &::before{
            left: 115px;
          }
        }
        &.Facebook{
          &::before{
            left: 145px;
          }
        }
        .QR-code {
          width: 70px;
          height: auto;
          margin-right: 20px;
        }
        .info {
          font-size: 12px;
          font-weight: 400;
          color: #000000;
          padding-top: 10px;
          text-align: left;
          line-height: 14px;
          p {
            margin: 0;
          }
          .icon {
            display: inline-block;
            width: 15px;
            height: auto;
            vertical-align: middle;
            margin-bottom: 5px;
          }
        }
      }
    }


    

    .wechat {
      position: relative;
      display: inline-block;

      .qrcode {
        display: none;
        position: absolute;
        left: 50%;
        bottom: 110%;
        transform: translate(-50%, 0);
        width: 200px;
        height: auto;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
        @media (max-width: 960px) {
          width: 100px;
          height: 100px;
          top: -110px;
          left: -40px;
          z-index: 2;
        }
      }

      &:hover .qrcode {
        display: block;
      }
    }

    .qrcode-box{
      position: relative;
      .app-list{
        position: relative;
        display: inline-block;
        margin-right: 20px;
        white-space: nowrap;
        cursor: pointer;
        img{
          margin-right: 8px;
        }
        .qrcode-list{
          position: absolute;
          bottom: calc(100% + 10px);
          right: 0;
          background: #fff;
          padding: 16px;
          border: 0.5px solid #DCDCDC;
          border-radius: 6px;
          box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
          display: none;
          gap: 20px;
          .qrcode{
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
              width: 68px;
              height: auto;
            }
          }
          &::after{
            content: '';
            width: 10px;
            height: 10px;
            background: #fff;
            position: absolute;
            bottom: -5px;
            right: 30px;
            transform: rotate(45deg);
          }
        }
        &:hover{
          .qrcode-list{
            display: flex;
          }
        }
      }
      
    }
    
  }

  .footer-wrapper {
    width: 75%;
    max-width: @maxWidth;
    margin: 0 auto;
    padding: 16px 0 0;
    color: rgba(0, 0, 0, 1);

    .footer-content {
      display: flex;

      .footer-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        // padding-right: 50px;
        text-align: left;

        ul {
          li {
            line-height: 22px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.7);
            margin-bottom: 10px;

            &.footer-title {
              font-size: 16px;
              line-height: 32px;
              color: rgba(0, 0, 0, 1);
              &.qrcode-title{
                margin-top: 32px;
              }
            }

            a {
              cursor: pointer;
              color: rgba(0, 0, 0, 0.7);

              &:hover {
                color: rgba(0, 0, 0, 0.6);
              }
            }
          }
        }
      }
    }
  }

  .copyright {
    display: flex;
    background: #e4e8ec;
    justify-content: center;
    margin-top: 22px;
    padding: 16px 0;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.7);
    line-height: 1;

    .footer-link {
      margin-left: 10px;
      color: rgba(0, 0, 0, 0.7);
      transition: all 0.3s;

      &:hover {
        text-decoration: underline;
      }

      &.footer-first-link {
        border-left: 1px solid rgba(0, 0, 0, 0.5);
        padding-left: 10px;
      }
    }
  }
}

@media (max-width: 960px) {
  footer {
    .footer-top {
      display: none;
      width: 100%;
    }

    .footer-wrapper {
      width: 100%;
      padding: 0;

      .footer-content {
        display: block;

        .footer-list {
          display: block;
          padding-right: 0;

          ul {
            position: relative;
            margin: 0;
            padding-left: 0;

            li {
              padding: 10px 16px;
              margin: 0px 16px;
              font-size: 10px;

              &.footer-title {
                font-size: 12px;
                border-bottom: 1px solid #e2e4e7;
                margin: 0;
                position: relative;
                display: block;

                i {
                  display: block;
                  position: absolute;
                  width: 8px;
                  height: 8px;
                  border-right: 1px solid #000;
                  border-bottom: 1px solid #000;
                  transform: rotate(45deg);
                  // background: url(../images/../images/assets/images/arrow-d.png) no-repeat center center;
                  // background-size: contain;
                  right: 30px;
                  top: 50%;
                  margin-top: -5px;
                  transition: all 0.3s;
                }

                &.active {
                  i {
                    transform: rotate(-135deg);
                    margin-top: -2px;
                  }
                }
              }
            }

            .footer-box-h5 {
              height: 0;
              overflow: hidden;
              transition: all 0.3s;
              opacity: 0;
            }

            .footer-active-h5 {
              &.footer-box-h5 {
                height: 100%;
                opacity: 1;
              }
            }
          }

          ul.app-list{
            .li-list{
              padding: 5px 0;
              .item-list{
                display: flex;
                justify-content: space-between;
                padding: 5px 0 22px 22px;
                div.box{
                  position: relative;
                  .qrcode{
                    display: none;
                    position: absolute;
                    bottom: calc(100% + 10px);
                    width: 128px;
                    height: 128px;
                    padding: 8px;
                    background: #fff;
                    img{
                      width: 100%;
                      height: 100%;
                    }
                    &::after{
                      content: '';
                      width: 10px;
                      height: 10px;
                      background: #fff;
                      position: absolute;
                      bottom: -5px;
                      right: 30px;
                      transform: rotate(45deg);
                    }
                  }
                  &:first-child{
                    .qrcode{
                      left: -35px;
                      &::after{
                        left: 60px;
                      }
                    }
                  }
                  &:nth-child(2){
                    .qrcode{
                      left: 50%;
                      transform: translateX(-50%);
                      &::after{
                        left: 65px;
                      }
                    }
                  }
                  &:nth-child(3){
                    .qrcode{
                      right: -15px;
                      &::after{
                        right: 60px;
                      }
                    }
                  }
                  &:hover{
                    .qrcode{
                      display: inline-block;
                    }
                  }
                }
                
              }
            }
            img {
              width: 16px;
              height: auto;
              margin-right: 8px;
              vertical-align: middle;
            }
          }
        }

        .footer-icon {
          display: flex;
          justify-content: center;
          padding: 5px 0 4px;

          li.footer-title {
            display: none !important;
          }

          img {
            margin: 0 7px;
            height: 16px;
          }
        }
      }
    }

    .copyright {
      margin-top: 0;
      padding: 16px;
      display: block;
      text-align: center;
      font-size: 9px;
      span{
        display: block;
      }
      .footer-link {
        display: inline-block;
        margin-top: 5px;
        text-decoration: underline;
        &.footer-first-link {
          border-left: 0;
          padding-left: 0;
        }
      }
    }
  }
}
</style>
